import {Button, Modal, message} from "antd";
import {Footer} from "../../public-profile/footer";
import {
  StyledProductDetailsMainSectionActionButtons,
  StyledProductDetailsMainSectionContainer,
  StyledProductDetailsPageContainer,
  StyledProductDetailsWrapper,
} from "./product-details.style";
import {ArrowLeftOutlined, ExclamationCircleOutlined} from "@ant-design/icons";
import {Link, useNavigate} from "react-router-dom";
import {ProductDetailsMainSection} from "./main-details";
import {useViewProductContext} from "../../../context/products/view-product-context";
import {useDigitalProductMutations} from "../../../features/digital-products";

export function ProductDetails() {
  const navigate = useNavigate();
  const {state} = useViewProductContext();
  const {deleteProduct} = useDigitalProductMutations();

  const handleDeleteModal = () => {
    Modal.confirm({
      title: `Confirm product deletion`,
      content:
        "Are you sure you want to delete this product? This action cannot be undone.",
      icon: <ExclamationCircleOutlined style={{color: "#F5222D"}} />,
      okText: "Delete product",
      cancelText: "Exit",
      okType: "danger",
      okButtonProps: {
        size: "small",
        type: "primary",
      },
      cancelButtonProps: {
        size: "small",
        type: "ghost",
      },
      onOk() {
        return new Promise((resolve, reject) => {
          if (state.productData.product.id) {
            resolve(
              deleteProduct(Number(state.productData.product.id), {
                onSuccess: () => {
                  message.success("The selected product has been deleted successfully!");
                  navigate("/products");
                },
                onError: (error) => {
                  message.error(
                    error.response?.data?.message ||
                      error.message ||
                      "Failed to delete product"
                  );
                },
              })
            );
          }
        }).catch(() => message.error("Failed to delete"));
      },
    });
  };

  return (
    <div style={{position: "relative", minHeight: "100vh"}}>
      <StyledProductDetailsWrapper>
        <StyledProductDetailsPageContainer>
          <Link to="/products">
            <Button icon={<ArrowLeftOutlined />} type="link" size="small">
              Back
            </Button>
          </Link>
          <StyledProductDetailsMainSectionContainer>
            <ProductDetailsMainSection />
            <StyledProductDetailsMainSectionActionButtons>
              <Link to={`/products/edit/${state.productData.product.id}`}>
                <Button className="product-main-details-action-btn" size="small">
                  Edit product
                </Button>
              </Link>
              <Button
                className="product-main-details-action-btn"
                onClick={handleDeleteModal}
                danger
                size="small"
                type="text"
              >
                Delete product
              </Button>
            </StyledProductDetailsMainSectionActionButtons>
          </StyledProductDetailsMainSectionContainer>
        </StyledProductDetailsPageContainer>
      </StyledProductDetailsWrapper>
      <Footer />
    </div>
  );
}
